export const maxMin = [
  [400, 1600],
  [1600, 7120],
  [24250, 86000],
  [86000, 100000],
];
